var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlassGold = function SvgMagnifyingGlassGold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 13.75a4.583 4.583 0 1 0 0-9.167 4.583 4.583 0 0 0 0 9.167Z",
    stroke: "#FFC83E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 12.5 3.333 3.333",
    stroke: "#FFC83E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgMagnifyingGlassGold as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTY2NzEgMTMuNzQ5N0MxMS42OTggMTMuNzQ5NyAxMy43NSAxMS42OTc2IDEzLjc1IDkuMTY2MzRDMTMuNzUgNi42MzUwNCAxMS42OTggNC41ODMwMSA5LjE2NjcxIDQuNTgzMDFDNi42MzU0IDQuNTgzMDEgNC41ODMzNyA2LjYzNTA0IDQuNTgzMzcgOS4xNjYzNEM0LjU4MzM3IDExLjY5NzYgNi42MzU0IDEzLjc0OTcgOS4xNjY3MSAxMy43NDk3WiIgc3Ryb2tlPSIjRkZDODNFIi8+CjxwYXRoIGQ9Ik0xMi41IDEyLjVMMTUuODMzMyAxNS44MzMzIiBzdHJva2U9IiNGRkM4M0UiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";